/* eslint-disable jira/filename-case */
import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

const supports = {
	scheduling(): boolean {
		// FIXME: this condition causes tests not to represent the real browser behaviour
		const win = getWindow();
		return !!win && typeof MessageChannel === 'function';
	},
};

export default supports;
